import { Autocomplete, LoadScript } from "@react-google-maps/api";
import { TimePicker } from "../../../../../components/inputs/MomentDatePicker";
import { Button, Divider, Form, Input, message, Modal, Popconfirm, Select, Table, Typography } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import MultipleUpload from "../../../../../components/inputs/UploadMultipleFile";
import { serverUrl } from "../../../../../nestserver";
const { Option } = Select;

const AddEditRoute = () => {
  const { Title } = Typography;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const format = "HH:mm";

  const [applyLeavePopup, setApplyLeavePopup] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [uploadAdmissionPopup, setUploadAdmissionPopup] = useState(false);
  const [parentFileList, setParentFileList] = useState([]);
  const [otherFields, setOtherFields] = useState([
    { name: "", coordinates: null, time: null },
  ]);

  const [allFields, setAllFields] = useState([
    { name: "", coordinates: null, time: null },
  ]);

  const [feeStops, setFeeStops] = useState([]);
  const [newFeeStopName, setNewFeeStopName] = useState("");
  const [editingFeeStop, setEditingFeeStop] = useState(null);
  const [editingFeeStopName, setEditingFeeStopName] = useState("");

  const handleOtherFieldChange = (value, index, field) => {
    const newFields = [...otherFields];

    if (field === "time" && value) {
      const timeInFormat = moment(value).format("HH:mm");
      newFields[index][field] = timeInFormat;
    } else {
      newFields[index][field] = value;
    }

    setOtherFields(newFields);
    setAllFields(newFields);
  };

  const addOtherField = () => {
    if (Array.isArray(otherFields)) {
      setOtherFields([
        ...otherFields,
        { name: "", time: null, coordinates: null },
      ]);
    } else {
      setOtherFields([{ name: "", time: null, coordinates: null }]);
    }
  };

  const removeOtherField = (index) => {
    if (index !== undefined && index >= 0) {
      const newFieldss = otherFields.filter((_, i) => i !== index);
      setOtherFields(newFieldss);
      const newFields = allFields.reduce((acc, field, i) => {
        if (i === index) {
          if (field.route_id) {
            acc.push({ ...field, is_deleted: true });
          }
        } else {
          acc.push(field);
        }
        return acc;
      }, []);
      setAllFields(newFields);
    }
  };

  async function getFormList() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/routes/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const formList = useQuery("/routes/", getFormList);

  const handleFileListChange = (fileList) => {
    setParentFileList(fileList);
  };
  async function fetchSubjects(id) {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/${id}`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const busDetails = useQuery(
    ["routes", editData],
    () => editData && fetchSubjects(editData),
    {
      enabled: !!editData,
    }
  );

  const feeStopsQuery = useQuery(
    ["route-fee-stops", editData],
    () =>
      axios
        .get(`${serverUrl}/admin/route-fee-stop?route_id=${editData}`, {
          headers: { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` },
        })
        .then((r) => r.data?.result || []),
    {
      enabled: !!editData && isEditMode,
      onSuccess: (data) => setFeeStops(data),
    }
  );

  //fetch bus
  async function getBusList() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/bus/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const busList = useQuery("/bus/", getBusList);

  //fetch driver
  async function getDriverList() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/driver/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const driverList = useQuery("/driver/", getDriverList);

  const columns = [
    {
      title: "Name",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center capitalize"
        >
          {`${record?.name}`}
        </div>
      ),
    },
    {
      title: "Bus",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => {
        return (
          <div
            key={record}
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {record?.bus?.name}
          </div>
        );
      },
    },
    {
      title: "Driver",
      dataIndex: [],
      key: "status",
      align: "center",
      render: (record, _, index) => {
        return (
          <div
            key={index}
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {`${record?.driver?.first_name} ${record?.driver?.last_name}`}
          </div>
        );
      },
    },
    {
      title: "Source",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center capitalize"
        >
          {record?.source}
        </div>
      ),
    },
    {
      title: "Destination",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center capitalize"
        >
          {record?.destination}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record, index) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className=" text-base font-semibold text-center cursor-pointer text-blue-500 "
          onClick={() => {
            setIsEditMode(true);
            setEditData(record?._id);
            setApplyLeavePopup(true);
          }}
        >
          <span className="text-blue-500">Edit</span>
        </div>
      ),
    },
  ];

  const authHeader = () => ({
    Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
  });

  const handleAddFeeStop = () => {
    if (!newFeeStopName.trim()) return;
    axios
      .post(
        `${serverUrl}/admin/route-fee-stop`,
        { name: newFeeStopName.trim(), route_id: editData, order: feeStops.length },
        { headers: authHeader() }
      )
      .then((res) => {
        setFeeStops((prev) => [...prev, res.data?.result]);
        setNewFeeStopName("");
        queryClient.invalidateQueries(["route-fee-stops", editData]);
      })
      .catch(() => message.error("Failed to add fee stop"));
  };

  const handleUpdateFeeStop = (id) => {
    if (!editingFeeStopName.trim()) return;
    axios
      .patch(
        `${serverUrl}/admin/route-fee-stop/${id}`,
        { name: editingFeeStopName.trim() },
        { headers: authHeader() }
      )
      .then(() => {
        setFeeStops((prev) =>
          prev.map((s) => (s._id === id ? { ...s, name: editingFeeStopName.trim() } : s))
        );
        setEditingFeeStop(null);
        setEditingFeeStopName("");
      })
      .catch(() => message.error("Failed to update fee stop"));
  };

  const handleDeleteFeeStop = (id) => {
    axios
      .delete(`${serverUrl}/admin/route-fee-stop/${id}`, { headers: authHeader() })
      .then(() => {
        setFeeStops((prev) => prev.filter((s) => s._id !== id));
        queryClient.invalidateQueries(["route-fee-stops", editData]);
      })
      .catch(() => message.error("Failed to delete fee stop"));
  };

  const onFinish = (values) => {
    const formattedOtherFields = otherFields
      ?.filter((field) => field && field.time && field.coordinates)
      .map((field) => {
        const time = moment(field.time, "HH:mm");
        return {
          ...field,
          time: time.isValid() ? time.format("HH:mm") : null,
        };
      });

    const updatedFormattedFields = allFields
      ?.filter((field) => field && field.coordinates)
      .map((field) => {
        const time = moment(field.time, "HH:mm");
        return {
          ...field,
          time: time.isValid() ? time.format("HH:mm") : null,
        };
      });

    const payload = {
      name: values?.name,
      source: values?.source,
      comments: values?.comments,
      destination: values?.destination,
      bus_id: values?.bus_id,
      driver_id: values?.driver_id,
      route_map: isEditMode
        ? updatedFormattedFields
        : formattedOtherFields && formattedOtherFields.length > 0
        ? formattedOtherFields
        : [],
    };
    // if (formattedOtherFields.length < 2 || updatedFormattedFields.length < 2) {
    //   return message.error("Please select atleast 2 points");
    // }
    if (payload) {
      if (isEditMode) {
        axios
          .put(`${serverUrl}/routes/${editData ? editData : null}`, payload, {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token"
              )}`,
            },
          })
          .then((res) => {
            queryClient.invalidateQueries("/routes/");
            form.resetFields();
            setApplyLeavePopup(false);
            setEditData(null);
            setIsEditMode(false);
            message.success(res?.data?.result?.message);
          })
          .catch((err) => {
            if (err?.response?.data?.error?.errors) {
              message.error(err?.response?.data?.error?.errors);
            }
          });
      } else {
        axios({
          method: "post",
          url: serverUrl + "/routes/",
          data: payload,
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        })
          .then((res) => {
            queryClient.invalidateQueries("/routes/");
            form.resetFields();
            setApplyLeavePopup(false);
            message.success(res?.data?.result?.message);
          })
          .catch((error) => {
            message.error(error?.response?.data?.error?.errors);
          });
      }
    }
  };

  useEffect(() => {
    if (isEditMode && busDetails.data) {
      const data = busDetails.data?.result?.data;
      form.setFieldsValue({
        name: data?.name,
        bus_id: data?.bus?._id,
        driver_id: data?.driver?._id,
        source: data?.source,
        destination: data?.destination,
        comments: data?.comments,
      });
    }
  }, [isEditMode, busDetails?.data, form]);

  useEffect(() => {
    const routeMap = busDetails?.data?.result?.data?.route_map;
    const newOtherFields = routeMap?.map((route) => ({
      name: route?.name || "",
      coordinates: route?.coordinates,
      time: route?.time ? moment(route?.time, format) : null,
      route_id: route?.route_id ? route?.route_id : null,
      is_deleted: route?.is_deleted,
      _id: route?._id,
    }));
    setAllFields(newOtherFields);
    setOtherFields(newOtherFields);
  }, [isEditMode, busDetails?.data]);
  return (
    <div>
      {" "}
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          <div className="flex justify-between items-center">
            <div className="text-2xl text-orange-500 font-semibold">
              Routes
            </div>
            <div className="text-right pt-4">
              <Button
                type="primary"
                size="large"
                onClick={() => setApplyLeavePopup(true)}
              >
                Add
              </Button>
            </div>
          </div>
          <div className="py-5">
            <Table
              rowKey="_id"
              columns={columns}
              dataSource={
                formList?.isSuccess &&
                formList?.data?.result?.data?.length > 0 &&
                formList?.data?.result?.data
                  ? formList?.data?.result?.data
                  : []
              }
              pagination={true}
              loading={formList?.isLoading}
            />
          </div>

          <Modal
            width={800}
            visible={applyLeavePopup}
            onOk={() => setApplyLeavePopup(false)}
            onCancel={() => {
              form.resetFields();
              setApplyLeavePopup(false);
              setEditData(null);
              setIsEditMode(false);
              setParentFileList([]);
              setOtherFields([]);
              setFeeStops([]);
              setNewFeeStopName("");
              setEditingFeeStop(null);
              form.resetFields();
            }}
            footer={null}
            forceRender
          >
            <h3 className="text-lg font-bold pb-3">
              {isEditMode ? "Update Routes" : " Add Routes"}
            </h3>
            <div className="bg-white rounded-2xl ">
              <Form
                form={form}
                layout="vertical"
                name="basic"
                onFinish={onFinish}
                autoComplete="off"
              >
                <div className="grid grid-cols-2 gap-x-4">
                  <Form.Item
                    label="Name"
                    name="name"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter name" />
                  </Form.Item>
                  <Form.Item
                    label="Bus"
                    name="bus_id"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Bus",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select Bus"
                      className="w-full bg-gray-300 capitalize"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {busList?.isSuccess &&
                        busList?.data?.result?.data?.map((data) => {
                          return (
                            <Option key={data._id} value={data._id}>
                              {data?.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </div>
                <div className="grid grid-cols-2 gap-x-4">
                  <Form.Item
                    name="driver_id"
                    label="Driver"
                    className="w-30"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Driver",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select Driver"
                      className="w-full bg-gray-300 capitalize"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {driverList?.isSuccess &&
                        driverList?.data?.result?.data?.map((data) => {
                          return (
                            <Option key={data._id} value={data._id}>
                              {`${data?.first_name} ${data?.last_name}`}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </div>
                <Form.Item
                  label="Comment"
                  name="comments"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value.length <= 100) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "Description must be at most 100 characters"
                        );
                      },
                    },
                  ]}
                >
                  <Input.TextArea
                    rows={3}
                    placeholder="Type a comment..."
                    className="w-full border focus:outline-none resize-none"
                    maxLength={100}
                  />
                </Form.Item>

                <Title level={4}>Routes Map and Schedule</Title>
                <LoadScript
                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                  libraries={["places"]}
                >
                  {otherFields?.map((field, index) => (
                    <div key={index} className="space-x-5 mb-2">
                      <h6 key={index} className="mb-8px capitalize">
                        Point {index + 1}
                      </h6>
                      <div className="flex ml-0px space-x-4 other-feild other-feildd">
                        <Form.Item
                          label={
                            <Autocomplete
                              onLoad={(autocomplete) => {
                                autocomplete.addListener(
                                  "place_changed",
                                  () => {
                                    const place = autocomplete.getPlace();
                                    if (place.geometry) {
                                      const coordinates = [
                                        place.geometry.location.lat(),
                                        place.geometry.location.lng(),
                                      ];
                                      setOtherFields((prevFields) => {
                                        const updatedFields = [...prevFields];
                                        updatedFields[index] = {
                                          ...updatedFields[index],
                                          name: place.formatted_address,
                                          coordinates,
                                        };
                                        return updatedFields;
                                      });
                                    }
                                  }
                                );
                              }}
                            >
                              <Input
                                value={otherFields[index]?.name}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const capitalizedValue =
                                    value.charAt(0).toUpperCase() +
                                    value.slice(1);
                                  handleOtherFieldChange(
                                    capitalizedValue,
                                    index,
                                    "name"
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "ArrowUp" ||
                                    e.key === "ArrowDown"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Enter Point"
                                className="w-24 flex"
                              />
                            </Autocomplete>
                          }
                          className="w-30"
                        >
                          <TimePicker
                            value={
                              otherFields[index]?.time
                                ? moment(otherFields[index]?.time, "HH:mm")
                                : null
                            }
                            onChange={(time) =>
                              handleOtherFieldChange(time, index, "time")
                            }
                            format="HH:mm"
                            className="mr-2"
                            placeholder="Select time"
                            minuteStep={5}
                          />
                        </Form.Item>
                        <Button
                          type="danger"
                          onClick={() => removeOtherField(index)}
                          className="ml-2"
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ))}
                  <div className="pb-4">
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={addOtherField}
                      className="mb-2"
                    >
                      Add
                    </Button>
                  </div>
                </LoadScript>
                {isEditMode && (
                  <>
                    <Divider />
                    <Title level={4}>Fee Stops <span style={{ fontSize: 13, fontWeight: 400, color: "#888" }}>(for billing – separate from GPS tracking)</span></Title>
                    <div className="mb-3">
                      {feeStops?.map((stop, idx) => (
                        <div key={stop._id} className="flex items-center gap-2 mb-2">
                          {editingFeeStop === stop._id ? (
                            <>
                              <Input
                                value={editingFeeStopName}
                                onChange={(e) => setEditingFeeStopName(e.target.value)}
                                onPressEnter={() => handleUpdateFeeStop(stop._id)}
                                style={{ maxWidth: 300 }}
                                autoFocus
                              />
                              <Button size="small" type="primary" onClick={() => handleUpdateFeeStop(stop._id)}>Save</Button>
                              <Button size="small" onClick={() => { setEditingFeeStop(null); setEditingFeeStopName(""); }}>Cancel</Button>
                            </>
                          ) : (
                            <>
                              <span className="text-gray-700">{idx + 1}. {stop.name}</span>
                              <Button
                                size="small"
                                onClick={() => { setEditingFeeStop(stop._id); setEditingFeeStopName(stop.name); }}
                              >Edit</Button>
                              <Popconfirm
                                title="Delete this fee stop?"
                                onConfirm={() => handleDeleteFeeStop(stop._id)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button size="small" danger>Delete</Button>
                              </Popconfirm>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className="flex items-center gap-2">
                      <Input
                        placeholder="Stop name (e.g. Ramalayam Temple)"
                        value={newFeeStopName}
                        onChange={(e) => setNewFeeStopName(e.target.value)}
                        onPressEnter={handleAddFeeStop}
                        style={{ maxWidth: 300 }}
                      />
                      <Button type="dashed" onClick={handleAddFeeStop}>+ Add Fee Stop</Button>
                    </div>
                  </>
                )}
                <div className="text-center mt-4">
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    {isEditMode ? "Update" : " Submit"}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
          <Modal
            width={800}
            visible={uploadAdmissionPopup}
            onOk={() => setUploadAdmissionPopup(false)}
            onCancel={() => {
              setUploadAdmissionPopup(false);
            }}
            footer={null}
          >
            <div>
              <MultipleUpload
                onFileListChange={handleFileListChange}
                parentResponse={parentFileList}
              />
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default AddEditRoute;
